// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6wkUr","toggleWrap":"styles_toggleWrap__ujkeQ","content":"styles_content__2sxmm","selectAreaCode":"styles_selectAreaCode__3SQTx"};